import type React from "react";
import { ReactComponent as Svg } from "./assets/pending-icon.svg";
import * as styles from "./Icon.module.scss";

type LegPendingProps = React.SVGProps<SVGSVGElement>;

export const LegPending = ({ className, ...props }: LegPendingProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
